import { api } from "@api/api";
import { Login } from "@modules/integration/types/login";
import { Validate } from "@modules/integration/types/validate";
import {
  LoginFormValues,
  ValidateFormValues,
} from "@modules/integration/validations";

const loginEndpoints: Record<string, string> = {
  neo: "/integrations/neo/login/",
  voalle: "/voalle/login/",
  surf: "/surf/login/",
  medlar: "/medlar/login/",
  mk: "/mk/login/",
  maxx: "/maxx/login/",
  youcast: "/youcast/login/",
  duobox: "/duobox/login/",
  isuper: "/isuper/login/",
  adapter: "/adapter/login/",
  leste: "/leste/login/",
  sercomtel: "/sercomtel/slogin/",
};

export async function loginService(data: LoginFormValues): Promise<any> {
  try {
    const { username, password, agreement_id, idp, integrated_login } = data;

    if (integrated_login && loginEndpoints[integrated_login]) {
      let payload: Record<string, any>;

      switch (integrated_login) {
        case "surf":
        case "medlar":
          payload = { document: username };
          break;
        case "sercomtel":
          payload = { document: username, password };
          break;
        default:
          payload = {
            username,
            password,
            agreement_id,
            idp: idp || integrated_login,
          };
          break;
      }

      const version = integrated_login === "neo" ? "v2" : "v1";
      const endpoint = `/${version}${loginEndpoints[integrated_login]}`;

      const { data: login } = await api.post(endpoint, payload);

      return login;
    }

    const { data: login } = await api.post<Login>("/v1/users/tokens/", {
      username,
      password,
      agreement_id,
      idp,
    }, {
      params: {
        integrationError: true,
      },
    });

    return login;
  } catch (error: any) {
    return error?.response?.data;
  }
}

export async function validateService(data: ValidateFormValues): Promise<any> {
  try {
    const { data: vinculate } = await api.post<Validate>(
      "/v2/agreement/vinculate/",
      {
        cpf: data.cpf,
      },
      {
        params: {
          agreement_id: data.agreement_id,
          integrationError: true,
        },
      }
    );

    return vinculate;
  } catch (error: any) {
    return error?.response?.data;
  }
}
